import { GenericEventsRouteProvider } from '@wix/data-tools-generic-events';
import { AppShell } from '../components/AppShell';
import { WinsBody } from '../components/symphony/wins/WinsBody';
import { usePageLoadBi } from '../lib/use-page-load-bi';

// `/wins` — the outcomes the agents achieved for the reader. Both phones have the same screen.
export default function WinsPage() {
  usePageLoadBi({ page_name: 'wins_page', page_version: 'v1_wins_page' }, { trackBack: true });
  return (
    <GenericEventsRouteProvider value="wins">
      <AppShell title="">
        <WinsBody />
      </AppShell>
    </GenericEventsRouteProvider>
  );
}
